import React from 'react';
  
import { BrowserRouter, Route, Router, Routes } from "react-router-dom";
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Dashboard from './Pages/Dashboard';
import Header from './Pages/Header/Header';
import Footer from './Pages/Header/Footer';
import Demo_Form from './Pages/Demo_Form';
import Demo_Table from './Pages/Demo_Table';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <BrowserRouter>
      <Routes>
       
        
        <Route path="/dashboard" Component={Dashboard} />
        <Route path="/demo" Component={Demo_Form} />
        <Route path="/demotable" Component={Demo_Table} />
      
      </Routes>
    </BrowserRouter>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
